const SvgIcon = ({ width='24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path d="M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904zM6 12h16"></path>
  </svg>
);
export default SvgIcon;

//const SvgIcon = ({ width='24', color = '#fff' }) => (
//  <svg
//    xmlns="http://www.w3.org/2000/svg"
//    width={width}
//    height={width}
//    fill="none"
//    stroke={color}
//    strokeLinecap="round"
//    strokeLinejoin="round"
//    strokeWidth="2"
//    viewBox="0 0 24 24"
//  >
//    <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11zM21.854 2.147l-10.94 10.939"></path>
//  </svg>
//);
//export default SvgIcon;

// const SvgIcon = ({ width='24' }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={width}
//     height={width}
//     fill="#e3e3e3"
//     viewBox="0 -960 960 960"
//   >
//     <path d="M120-160v-640l760 320zm80-120 474-200-474-200v140l240 60-240 60zm0 0v-400z"></path>
//   </svg>
// );
// export default SvgIcon;
